import { docsConsoleHomeIntro, docsConsoleHomeTitle } from 'Clepit/translations';
import type { SupportedLanguage } from '@bomdisoft/translations';
import type { EditorData } from '@clepit/core';

/** Derived from `app/[lang]/dashboard/screen.tsx`, `app/console-shell.tsx`,
 * `app/console-nav.tsx`, and `app/[lang]/onboarding`. */
export const buildConsoleHome = (language: SupportedLanguage): EditorData => ({
  blocks: [
    { data: { html: docsConsoleHomeTitle[language], level: 'h1' as const }, type: 'header' },
    { data: { html: docsConsoleHomeIntro[language] }, type: 'paragraph' },

    { data: { alt: 'The console Home screen', caption: 'Home: favourites, recents, and the navigation rail.', url: '/images/docs/console/home/screen-light.png' }, type: 'image' },
    { data: { alt: 'The console Home screen, dark theme', caption: 'Home: favourites, recents, and the navigation rail.', url: '/images/docs/console/home/screen-dark.png' }, type: 'image' },

    { data: { html: 'Favourites and Recents', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'Two lists, and nothing else competing for the screen. Favourites holds the documents you starred from their header; Recents holds what was opened lately, newest first. Each row is a link straight into the document. An empty list says it is empty rather than showing a blank, and a failed load shows the failure with a retry button instead of posing as an empty account.',
      },
      type: 'paragraph',
    },

    { data: { html: 'The navigation rail', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'The rail on the left carries the console: Pages for the document tree, Ask (which announces itself as coming rather than pretending), Search (which opens the palette over the current screen rather than leaving it), Updates with its unread count, and Settings, with billing reached from the account menu as an external surface. The rail collapses to a thin strip and expands again from the strip itself, so a document can take the whole width without losing the way back.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Channels', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'Below the fixed rows, the rail lists the workspace channels: the top-level spaces of the page tree, each expanding to the documents it holds. The section header carries a filter and a create button, and creating a channel is creating a top-level page. An empty workspace says it has no channels yet instead of showing a blank strip, and a failed load says it failed.',
      },
      type: 'paragraph',
    },

    { data: { html: 'First run', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'A new account lands on onboarding: name the workspace, create it, and arrive at Home. That is the whole ceremony; everything else is configured later in settings.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Where this meets the docs', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'Every document row opens the surface described in <a href="./documents">Documents</a>. The rail badge behaviour is covered in <a href="./updates">Updates</a>.',
      },
      type: 'paragraph',
    },
  ],
  time: 1_745_000_000_000,
  version: '1.0.0',
});
